// extracted by mini-css-extract-plugin
export default {"rating":"xJ-z","numberOfStars":"yJ-z","count":"zJ-z","barGraphSpacing":"AJ-z","barGraph":"BJ-z"};